import React from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="bg-white text-gray-900 py-8 px-6 shadow-md">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10">
        {/* Left Text Content */}
        <div className="flex-1 text-center md:text-left">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-blue-600 leading-tight mb-4">
            Gaming at Your Fingertips
          </h1>
          <p className="text-lg sm:text-xl text-gray-700 mb-6">
            Track upcoming releases, discover new favorites, and never miss a game launch again.
          </p>
          <Link to="/signup">
            <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-2xl transition duration-300">
              Sign Up
            </button>
          </Link>
        </div>

        {/* Right Illustration */}
        <div className="flex-1 hidden md:block">
          <img
            src="/HeroSectionLogo.png"
            alt="Gaming console illustration"
            className="w-full max-w-md mx-auto"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
